import { useState, useRef, useEffect } from "react";
import styles from "./TopHeader.module.scss";
import ArrowDown from "../../../assets/svgs/header/ArrowDown";
import { useCurrencies } from "../../../context/CurrenciesContext";
import { useLanguage } from "../../../context/LanguageContext";
import useLanguages from "../../../constants/languages";
import { useTranslation } from "react-i18next";
import ThemeToggle from "../../common/theme-toggle/ThemeToggle";

const TopHeader = () => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const { currencies, currency, setCurrency, setCurrencyId } = useCurrencies();
  const { currentLanguage, changeLanguage, getCurrentLanguageDisplayName } =
    useLanguage();
  const languages = useLanguages();
  const { t } = useTranslation("translation");
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = (type: string) => {
    setOpenDropdown(openDropdown === type ? null : type);
  };

  const handleLanguageSelect = (langCode: string) => {
    changeLanguage(langCode);
    setOpenDropdown(null);
  };

  const handleCurrencySelect = (value: string, id?: number) => {
    setCurrency(value);
    if (id) setCurrencyId(id);
    setOpenDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.top}>
      <div className="container">
        <div className={styles.top_content}>
          <div className={styles.info}>
            <div className={styles.hotline}>{t("hotline")}</div>
            <a href="tel:+994517003500" className={styles.number}>
              +994517003500
            </a>
          </div>

          <div className={styles.dropdown_group} ref={dropdownRef}>
            <ThemeToggle />
            <div className={styles.dropdown}>
              <button
                className={styles.dropdown_btn}
                onClick={() => toggleDropdown("lang")}
              >
                <p>{getCurrentLanguageDisplayName()}</p>
                {languages?.length > 1 && <ArrowDown />}
              </button>
              <div
                className={`${styles.dropdown_menu} ${styles.lang_menu} ${
                  languages?.length > 1 && openDropdown === "lang"
                    ? styles.show
                    : ""
                }`}
              >
                {languages?.map((lang) => (
                  <div
                    key={lang.id}
                    onClick={() => handleLanguageSelect(lang.code)}
                    className={`${styles.dropdown_item} ${
                      currentLanguage === lang.code ? styles.active : ""
                    }`}
                  >
                    {lang.name}
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.dropdown}>
              <button
                className={styles.dropdown_btn}
                onClick={() => toggleDropdown("curr")}
              >
                <p>{currency}</p>

                {currencies?.length > 1 && <ArrowDown />}
              </button>
              <div
                className={`${styles.dropdown_menu} ${
                  currencies?.length > 1 && openDropdown === "curr"
                    ? styles.show
                    : ""
                }`}
              >
                {currencies?.map((cur) => (
                  <div
                    key={cur.id}
                    onClick={() => handleCurrencySelect(cur.name, cur.id)}
                    className={`${styles.dropdown_item} ${
                      currency === cur.name ? styles.active : ""
                    }`}
                  >
                    {cur.name}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
